import { AdPlacementCode, LEADERBOARD_FORMATS } from 'elements/ads/AdPlacements'
import useAdBanner from 'elements/ads/useAdBanner'
import type { ComponentTypesV2 } from 'types/selectComponent'
import { mapComponentTypesV2ToV1 } from 'util/misc'
import HardwareAdBannerContainer from './HardwareAdBannerContainer'

export const getHardwareSelectorAdPlacement = ({
  location,
  searchText = '',
  componentType,
}: {
  location: 'top' | 'bottom'
  searchText?: string
  componentType?: ComponentTypesV2
}): AdPlacementCode | undefined => {
  if (componentType) {
    // Normalize componentType to V1 format
    const normalizedType = mapComponentTypesV2ToV1(componentType)
    return `hardware_selection_${normalizedType}_${location}` as AdPlacementCode
  } else if (searchText) {
    return `hardware_search_${location}` as AdPlacementCode
  }
  return undefined
}

const HardwareSelectorTopBanner = ({
  searchText,
  componentType,
}: {
  searchText: string
  componentType?: ComponentTypesV2
}) => {
  const adPlacementTop = getHardwareSelectorAdPlacement({ location: 'top', searchText, componentType })
  const AdBanner = useAdBanner({
    formats: LEADERBOARD_FORMATS,
    placement: adPlacementTop,
  })

  if (AdBanner != null) {
    return <HardwareAdBannerContainer> {AdBanner} </HardwareAdBannerContainer>
  }

  return null
}

export default HardwareSelectorTopBanner
